import { allFeaturesAtFalse, type Features } from './default'

export const features: Features = {
  ...allFeaturesAtFalse,
  home: {
    ...allFeaturesAtFalse.home,
    advantages: false,
  },
  contact: {
    mailTo: 'contact@countrymalt.com',
  },
  footer: {
    ...allFeaturesAtFalse.footer,
    logo: '/themes/current/images/logo_2.svg',
    social: {
      facebook: 'https://www.facebook.com/countrymalt',
      linkedin: 'https://www.linkedin.com/company/the-country-malt-group',
      instagram: 'https://www.instagram.com/countrymalt',
      youtube: 'https://www.youtube.com/c/CountryMaltGroup',
    },
    legals: {
      termsOfUse: { label: `Terms`, linksTo: { name: 'legals' }, tag: 'router-link' },
      personalData: { label: `Données personnelles`, linksTo: { name: 'privacy' }, tag: 'router-link' },
      cookiePolicy: { label: `Paramétrer les cookies`, click: () => { }, tag: 'button' },
      legalNotice: { label: `Mentions légales`, linksTo: { name: 'legal-notice' }, tag: 'router-link' },
    },
    languagePicker: true,
  },
  plp: {
    offSeasonBadge: true,
  },
  equalWeb: true,
  clickDimensions: true,
  axeptio: {
    i18n: {
      cases: {
        default: 'cmg-US-en',
        'en-US': 'cmg-US-en',
        'en-CA': 'cmg-CA-en',
        'fr-CA': 'cmg-CA-fr',
      },
    },
  },
  checkoutV2: {
    hasAddOns: true,
    hasPickupPointFree: true,
    displayToBeCalulated: true,
  },
  pdp: {
    templateB2AGFeature: false,
    showOnlyMainImage: false,
    showSupplier: true,
    showSupplierUniverseLink: true,
  },
  customer: {
    associatedAccounts: {
      dissociationLabelIdentifier: 'email',
    },
  },
  myAccount: {
    profile: {
      shouldHideCountry: false,
    },
  },
  seo: {
    useDescriptionFromProduct: true,
  },
  platform: {
    name: 'Country Malt Group',
  },
  inLanguage: 'en-US',
  webSite: {
    name: 'Country Malt Group - Home | Country Malt Group',
    url: 'https://www.countrymalt.com/',
    searchTargetUrl: 'https://www.countrymalt.com/products?query={search_term_string}',
  },
}
